<app-navbar [title]="'Pojazdy'">
	<a routerLink="./add" class="btn btn-danger"> <i class="fas fa-plus"></i> Dodaj </a>
</app-navbar>

<app-vehicles-filters
	userFilters="vehicles"
	[parameters]="parameters"
	(selected)="filtersSelected($event)"
></app-vehicles-filters>

<app-dynamic-table
	module="vehicles"
	[elements]="data"
	[tableRows]="tableRows"
	(filtersClicked)="filtersOpen()"
></app-dynamic-table>
